import { Mail } from "lucide-react";
import { toast } from "sonner";
import Reveal from "./Reveal";
import { useLanguage } from "../context/LanguageContext";
import { AppleIcon, GooglePlayIcon } from "./icons";

const DownloadCTA = () => {
  const { t } = useLanguage();

  return (
    <section className="relative overflow-hidden py-24 sm:py-32" data-testid="download-section">
      <div className="pointer-events-none absolute inset-0 bg-gradient-to-br from-sky-600 via-sky-700 to-slate-900" />
      <div className="pointer-events-none absolute -top-24 end-10 h-72 w-72 rounded-full bg-amber-400/20 blur-3xl" />
      <div className="pointer-events-none absolute bottom-0 start-10 h-72 w-72 rounded-full bg-sky-300/20 blur-3xl" />

      <div className="relative mx-auto max-w-4xl px-4 text-center sm:px-8">
        <Reveal>
          <img
            src="/logo-app.png"
            alt="LingoMind"
            className="mx-auto mb-8 h-20 w-20 rounded-3xl shadow-2xl shadow-black/30"
          />
          <p className="font-mono text-xs font-semibold uppercase tracking-[0.25em] text-amber-300">
            {t.download.overline}
          </p>
          <h2 className="mt-4 font-heading text-3xl font-extrabold tracking-tight text-white sm:text-4xl lg:text-5xl">
            {t.download.title}
          </h2>
          <p className="mx-auto mt-4 max-w-xl text-base text-sky-100/90 sm:text-lg">
            {t.download.subtitle}
          </p>
        </Reveal>

        <Reveal delay={0.15}>
          <div className="mt-10 flex flex-wrap items-center justify-center gap-4">
            <a
              data-testid="cta-google-play-button"
              href="https://play.google.com/store/apps/details?id=com.lingomind.app&hl=en"
              target="_blank"
              rel="noopener noreferrer"
              className="transition-all hover:-translate-y-0.5 hover:drop-shadow-2xl"
            >
              <img src="/google-play-badge.png" alt={t.download.googlePlay} className="h-16 w-auto" />
            </a>
            <button
              data-testid="cta-app-store-button"
              onClick={() => toast.info(t.hero.appStoreSoon)}
              className="flex items-center gap-3 rounded-2xl bg-white px-7 py-4 text-slate-900 shadow-2xl transition-all hover:-translate-y-0.5"
            >
              <AppleIcon className="h-8 w-8" />
              <span className="text-start">
                <span className="block text-base font-extrabold leading-tight">{t.hero.appStoreCta}</span>
              </span>
            </button>
          </div>
          <a
            data-testid="cta-support-email"
            href="mailto:support@lingomind.app"
            className="mt-8 inline-flex items-center gap-2 text-sm font-semibold text-sky-100 transition-colors hover:text-amber-300"
          >
            <Mail className="h-4 w-4" />
            {t.download.support}: support@lingomind.app
          </a>
        </Reveal>
      </div>
    </section>
  );
};

export default DownloadCTA;
